import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class AddPromotionBlock extends HTMLDivElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.initEvents();
    }

    getElementAddCodePromo() {
        return this.querySelector(this.getSelectorValueCodePromo());
    }

    getSelectorValueCodePromo() {
        return 'input[name="promocode"]';
    }

    getSelectorApplyCodePromo() {
        return '.promo-code-input button, .promo-code-input button i';
    }

    getNoValideCodeElement() {
        return $('#no_valide_code');
    }

    applyCodePromo(container) {
        const code = this.getElementAddCodePromo().value;

        if (code.length === 0) {
            this.getNoValideCodeElement().show();

            return false;
        }

        var requestor = new Requestor();

        requestor.sendRequest( this.getElementAddCodePromo().dataset.route, 'POST', {
            code: code,
            return_templates: ['cart-prices','cart-promotion-apply']
        }, (data) => {
            toastr.success(data.text);

            container.updateCartIndexView(data);
        }, (data) => {
            var noValideCodeElement = this.getNoValideCodeElement();

            noValideCodeElement[0].innerHTML = data.responseJSON.text;
            noValideCodeElement[0].style.display = 'block';

            this.getElementAddCodePromo().classList.add('is-invalid');
        })
    }

    initEvents() {
        this.querySelector(this.getSelectorApplyCodePromo()).addEventListener('click',  (e) => {
            e.preventDefault();

            this.applyCodePromo(this.mainContainer);
        });
    }
};

